import { isUnassignedOptionId } from "src/data/taskManagement/taskManagementFilters"
import { usePatchTask } from "src/data/taskManagement/taskManagementQueries"
import { TTask } from "src/data/taskManagement/taskManagementTypes"

import { AssigneeCombobox } from "./AssigneeCombobox"

export function AssigneeColumn({
  assignee,
  taskId,
  orgId,
}: {
  assignee: TTask["assigned_to"]
  taskId: string
  orgId: string
}) {
  const patchTask = usePatchTask()

  function handleAssigneeChange(assigneeId: string) {
    if (isUnassignedOptionId(assigneeId)) {
      patchTask.mutate({
        path: {
          organization_id: orgId,
          task_id: taskId,
        },
        body: { assigned_to: null },
      })
    } else {
      patchTask.mutate({
        path: {
          organization_id: orgId,
          task_id: taskId,
        },
        body: { assigned_to: { type: "member", assignee_id: assigneeId } },
      })
    }
  }

  return (
    <AssigneeCombobox
      initialValue={assignee?.assignee_id ?? ""}
      onChange={handleAssigneeChange}
    />
  )
}
